import { isPresent } from '@ember/utils';
import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import { DEFAULT_VALUES as DEFAULT_QUERY_PARAMS } from 'cio/pods/message-library/controller';

const Transforms: TransformsList = {
  messagesQueried(data: Data) {
    let { route } = data;
    if (!route) {
      return {};
    }

    let { query, sortBy, sortDirection } = route.queryParams;

    return {
      'Search term': isPresent(query) ? query : DEFAULT_QUERY_PARAMS.query,
      'Sorted By': isPresent(sortBy) ? sortBy : DEFAULT_QUERY_PARAMS.sortBy,
      'Sort Direction': isPresent(sortDirection) ? sortDirection : DEFAULT_QUERY_PARAMS.sortDirection,
    };
  },
};

export default Transforms;
